<template>
    <div id="topBar" class="topBar" :class="{active: settings.active}">
        <div class="wrapTop">
            <div class="leftBox">
                <div class="menuIcon" @click="$emit('menuopen')" v-if="!settings.showBackButton">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="d-flex backIcons" v-else>
                    <img v-if="settings.showX" :src="getStaticImage('icons/top_bar/close.png')" @click="cancelOrder">
                    <img v-else-if="settings.showBackButton" :src="getStaticImage('icons/top_bar/back_button.png')"
                         @click="$router.go(-1)">
                </div>
            </div>
            <div class="titleSearchBox">
                <transition
                    tag="div"
                    enter-active-class="fadeInUp"
                    leave-active-class="fadeOutUp"
                >
                <div
                    v-if="settings.title"
                    :key="'title_' + settings.title "
                    style="animation-duration: .5s;"
                >
                    <div class="h1" :class="settings.smallText ? 'small_text caption' : '' " v-html="settings.title"></div>
                </div>
                </transition>
            </div>
            <div class="rightIcon">
                <img
                    v-if="settings.showLocationSearch"
                    :src="getStaticImage('icons/top_bar/search.png')"
                    @click="showSearchBar = !showSearchBar"
                />
                <div
                    class="bag"
                    v-if="settings.showBag"
                    @click="$router.push({name: 'Cart'})"
                >
                    <div
                        class="quantity"
                        v-if="totalCartQuantity"
                        :class="{small: (totalCartQuantity>9)}"
                    >
                        <span>{{totalCartQuantity<100 ? totalCartQuantity : "99+" }}</span>
                    </div>
                    <img
                        :src="getStaticImage('icons/cart.png')"
                    />
                </div>
            </div>
        </div>
        <transition
            enter-active-class="fadeInDown"
            leave-active-class="fadeOutUp"
        >
            <LocationSearchBar
                v-if="showSearchBar && settings.showLocationSearch"
            />
        </transition>
        <div class="descktopMediaBox">
            <header>
                <div class="headWrap">
                    <div class="logoBox">
                        <router-link :to="{name: 'Home'}">
                            <img :src="getStaticImage('logo.png')"/>
                        </router-link>
                        <div class="mininav">
                            <a href="#" @click.prevent="$emit('menuopen')">
                                menu
                            </a>
                            <router-link :to="{name: 'Transaction History'}">
                                REWARDS
                            </router-link>
                            <router-link :to="{name: 'E-gifts'}" >
                                E-gifts
                            </router-link>
                        </div>
                    </div>
                    
                    <div class="loginSection">
                        <div v-if="!user" class="notreg">
                            <div class="login h4">
                                <router-link :to="{name:'Login'}">Log in</router-link>
                            </div>
                            <span> / </span>
                            <div class="reginster h4">
                                <router-link :to="{name:'Registration'}">Join</router-link>
                            </div>
                            <div
                                class="bag"
                                @click="$router.push({name: 'Cart'})"
                            >
                                <div
            
                                    v-if="totalCartQuantity"
                                    class="quantity"
                                    :class="{ small : ( +totalCartQuantity > 9 ) }"
                                >
                                    <span>{{totalCartQuantity<100 ? totalCartQuantity : "99+" }}</span>
                                </div>
                                <img
                                    :src="getStaticImage('icons/cart.png')"
                                />
                            </div>
                        </div>
                        <div v-else>
                            <router-link :to="{name: 'Locations'}" class="btnlink">
                                Start Order
                            </router-link>
                            <div class="logout h4" @click="$store.dispatch('user/logout')">
                                LOG OUT
                            </div>
                            <router-link :to="{name: 'AccountInformation'}" class="accaunt">
                                <img :src="getStaticImage('account.png')"/>
                            </router-link>
                            <router-link class="bag" :to="{name: 'Cart'}">
                                <div
        
                                    v-if="totalCartQuantity"
                                    class="quantity"
                                    :class="{ small : ( +totalCartQuantity > 9 ) }"
                                >
                                    <span>{{totalCartQuantity<100 ? totalCartQuantity : "99+" }}</span>
                                </div>
                                <img
                                    :src="getStaticImage('icons/cart.png')"
                                />
                            </router-link>
                        </div>
                    </div>
                </div>
            </header>
        </div>
    </div>
</template>

<script>
    import LocationSearchBar from "./locations/LocationSearchBar";
    export default {
        name: "TopBar",
        components: {LocationSearchBar},
        props: ['menuopen'],
        data(){
            return{
                showSearchBar: false
            }
        },
        methods:{
            cancelOrder() {
                this.$modal.show("promt-modal", {
                    title: "Warning!", content: "Are you sure you want to cancel your order?", success: () => {
                        this.$router.push({name: 'Home'});
                        this.$store.commit("cart/resetCart");
                    }
                })
            }
        },
        computed: {
            settings() {
                return this.$store.state.shared.topBar;
            },
            totalCartQuantity(){
                return this.$store.state.cart.cart.calcTotalCartQuantity()
            }
        }
    }
</script>
